function changeResponse() {
    $('input[type="radio"][name="response"]').not(':checked').prop("checked", true);
}

$(document).on('turbolinks:load', function () {
    $('#accept-match').on("click", function (e) {
        changeResponse()
    })
});